<div class="flex min-h-[60vh] flex-col items-center justify-center text-center px-4">
  <div class="mb-6 flex h-24 w-24 items-center justify-center rounded-full" style="background: var(--muted)">
    <span class="text-5xl font-bold" style="color: var(--muted-foreground)">404</span>
  </div>
  <h1 class="text-3xl font-bold mb-2" style="color: var(--foreground)">Page Not Found</h1>
  <p class="text-base mb-8 max-w-md" style="color: var(--muted-foreground)">
    Sorry, the page you're looking for doesn't exist or has been moved.
  </p>
  <a routerLink="/"
    class="inline-flex items-center justify-center rounded-lg px-6 py-3 text-sm font-medium text-white no-underline transition-colors"
    style="background: var(--primary-600)">
    Go Home
  </a>
</div>
